import { render, staticRenderFns } from "./social-share.vue?vue&type=template&id=1b504aa2&scoped=true&"
import script from "./social-share.vue?vue&type=script&lang=js&"
export * from "./social-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b504aa2",
  null
  
)

export default component.exports